// import { HashRouter as Router, Routes, Route } from "react-router-dom";
// import Nav from "../components/Nav";
// import OurHacksPM from "./OurHacksPM";
// import LandingPage from "./LandingPage"; 
// import OurHacksMA from "./OurHacksMA";
// import OurHacksCEO from "./OurHacksCEO";
// import OurHacksLG from "./OurHacksLG";


// export default function App() {
//   return (
//     <Router>
//       <Nav />
//       <Routes>
//         <Route path="/" element={<LandingPage />} />
//         <Route path="/ourhacks/pm" element={<OurHacksPM />} />
//         <Route path="/ourhacks/ma" element={<OurHacksMA />} />
//         <Route path="/ourhacks/ceo" element={<OurHacksCEO />} />
//         <Route path="/ourhacks/lg" element={<OurHacksLG />} />
//       </Routes>
//     </Router>
//   );
// }


export default function App() {
  return null; 
}
